import { pluralise } from '@/utilities/pluralise';

type GetRecentResultsToggleTextParams = {
  newCompaniesCount?: number | null;
  isQueryRestricted?: boolean | null;
};

export const getRecentResultsToggleText = ({
  newCompaniesCount,
  isQueryRestricted,
}: GetRecentResultsToggleTextParams) => {
  const newPrefix = isQueryRestricted ? 'New' : `${newCompaniesCount ?? 0} new`;
  const companiesText = pluralise(newCompaniesCount, 'company', 'companies');
  return `${newPrefix} ${companiesText} last 7d`;
};
